import React from 'react'

import MaintenanceView from '../../../domain/maintenance/container/MaintenanceView'

import MaintenanceError from './MaintenanceError'

interface Props {
  children: React.ReactNode
}

interface State {
  error?: Error
}

class MaintenanceErrorBoundary extends React.PureComponent<Props, State> {
  public state: State = {}

  public static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  public render(): React.ReactNode {
    if (this.state.error) {
      // If error is not of the correct type, rethrow to be caught by a boundary higher up in the tree
      if (!(this.state.error instanceof MaintenanceError)) {
        throw this.state.error
      }
      return <MaintenanceView message={this.state.error.message} />
    }

    return this.props.children
  }
}

export default MaintenanceErrorBoundary
